<template>
	<search-list ref="sl" apiPath="/advSummary/list" :where="where" :order="order" :searchKeys="searchKeys" >
		<mm-lc title="Period">
			<mm-month-picker v-model="where.time" />
		</mm-lc>
		<mm-lc title="Status Date">
			<mm-date-range v-model="where.status_date" :notDefaultValue="true" :showChangeType="false" :dateValue="true"/>
		</mm-lc>
		<mm-lc title="Advertiser">
			<mm-adv-select v-model="where.adv_id" multiple/>
		</mm-lc>
		<mm-lc title="Manager">
			<mm-users v-model="where.manager" multiple/>
		</mm-lc>
		<mm-lc title="Auth Manager" v-show="is_show_auth">
			<mm-users v-model="where.auth_manager" multiple not_admin></mm-users>
		</mm-lc>
		<!-- <mm-lc title="Operator">
			<mm-users v-model="where.operator" multiple/>
		</mm-lc> -->
		<mm-lc title="status"  v-if="is_show_status">
			<mm-summary-status v-model="where.status" multiple/>
		</mm-lc>
		<mm-lc title="Invoice Status">
			<mm-invoice-status v-model="where.invoice_status" />
		</mm-lc>
		<mm-lc title="Payout Type">
			<mm-payout-type-select v-model="where.payout_type" multiple/>
		</mm-lc>
		<el-dropdown size="mini" trigger="click" slot="statusAction">
			<el-button size="small" type="primary" icon="el-icon-edit">
				Batch Op
			</el-button>
			<el-dropdown-menu slot="dropdown">
				<el-dropdown-item class="status-active" @click.native="invoiceDownload">Invoice Download</el-dropdown-item>
				<el-dropdown-item @click.native="copyFinRev">Copy Fin Rev</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
		<el-button slot="actions" type="success" class="el-icon-document-add" @click="showAddDialog = true"></el-button>
		<mm-table slot="dataTable" slot-scope="res" :res="res" @sort-change="sortChange" @selection-change="selectionChange" >
			<el-table-column type="selection" fixed="left"/>
			<el-table-column label="Time" prop="period" fixed  />
			<el-table-column label="Adv name" prop="adv_name" fixed >
				<mm-get-detail slot-scope="sp" :row_name="sp.row.adv_name" :row_id="sp.row.adv_id" :class_name="sp.row.amount_status === 'confirm' ? 'status-confirm' : ''" row_type="adv" />
			</el-table-column>
			<mm-summary-column label="Conv" prop="conv" sortable="custom" />
			<mm-summary-column label="Rev" prop="snt_rev" width="93" sortable="custom"/>
			<mm-summary-column label="Adv Rev" prop="adv_rev"  width="106" sortable="custom"/>
			<mm-summary-column label="Deducted Amount" prop="ded_amount"  width="107" sortable="custom"/>
			<mm-summary-column label="Hold On Amount" prop="hold_on_amount"  width="103" sortable="custom"/>
			<mm-summary-column label="Final Revenue" prop="confirm_amount"  width="110" sortable="custom"/>
			<mm-summary-column label="Received Amount" prop="received_amount"  width="175" sortable="custom"/>
			<mm-summary-column label="Margin" prop="margin"  width="90" />
			<mm-summary-column label="Ded.Rate" prop="ded_rate"  width="90"/>
			<el-table-column label="Manager" prop="manager" />
			<el-table-column label="Operator" prop="operator" />
			<el-table-column label="Payout Type" prop="payout_type"  width="105"/>
			<el-table-column label="Status Date" prop="status_date"  width="130" sortable="custom"/>
			<el-table-column label="status" prop="status" fixed="right" v-if="is_show_status" >
				<span slot-scope="sp" :class="'status-'+sp.row.status.trim()">{{sp.row.status.toUpperCase()}}</span>
			</el-table-column>
			<el-table-column label="Invoice Status" prop="invoice_status" width="85" fixed="right" >
				<span slot-scope="sp" :class="'status-'+sp.row.invoice_status">{{sp.row.invoice_status.toUpperCase()}}</span>
			</el-table-column>
			<el-table-column label="action" fixed="right" >
				<template slot-scope="sp">
					<el-button type="warn" @click.native="edit(sp.row)">Edit</el-button>
				</template>

			</el-table-column>

		</mm-table>

		<el-dialog :visible.sync="showAddDialog">
			<span slot="title">Add Adv Summary</span>
			<el-form label-width="200px" :model="addForm" ref="addForm">
				<el-form-item label="Adv" required prop="adv_id">
					<mm-adv-select v-model="addForm.adv_id" style="width:300px"/>
				</el-form-item>
				<el-form-item label="Time" required prop="time">
					<el-date-picker append-to-body v-model="addForm.time" :picker-options="pickerOptions" type="month" value-format="yyyy-MM" style="width:300px"/>
				</el-form-item>
				<el-form-item class="form-item">
					<el-button type="primary" @click="addSummary">Save</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</search-list>
</template>

<script>
import { attachmentDownload } from '@/lib/index'
export default {
	data() {
		const searchKeys = {
			adv_id: { label: "Adv Id" },
			adv_name: { label: "Adv Name",fuzzy:true },
			invoice_file: { label: "Invoice",fuzzy:true },
		};
		const user_info = this.$utils.getCookies(['group_name','is_super']);
		const is_show_auth = (user_info.group_name === 'admin');
		const is_show_status = user_info.is_super == '1';
		return {
			searchKeys,
			where: {
			},
			order:[],
			is_show_auth,
			is_show_status,
			addForm: {},
			showAddDialog: false,
			pickerOptions: {
				disabledDate: (date) => {
					const nowMonth = this.$utils.date_format((new Date()),'YYYY-MM');
					if (new Date(date).getTime() < new Date(nowMonth).getTime() - 24 * 60 * 60 * 1000) {
						return false;
					}
					return true;
				}
			},
			selected: [],
		};
	},
	methods: {
		selectionChange(v) {
			this.selected = v || [];
		},
		copyFinRev() {
			if (!this.selected.length) {
				this.$message({ message: "no selection!", type: "warning" });
				return;
			}
			let text = '';
			let total = 0;
			for (const row of this.selected) {
				text += row.period + '\t' + row.adv_name + '\t' + row.confirm_amount + '\r';
				total += Number(row.confirm_amount);
			}
			text += 'Total\t' + total;
			this.$copyText(text);
			this.$message.success('Copy Success');
		},
		async invoiceDownload() {
			if (!this.selected.length) {
				this.$message({ message: "no selection!", type: "warning" });
				return;
			}
			const errArr = [];
			const emtyArr = [];
			for(const row of this.selected) {
				if (row.invoice_file) {
					const invoice_files = JSON.parse(row.invoice_file);
					for (const fileInfo of invoice_files) {
						if (fileInfo && fileInfo.file_path) {
							attachmentDownload(fileInfo);
						} else {
							errArr.push(row.adv_name);
						}
					}
				} else {
					emtyArr.push(row.adv_name);
				}
			}
			let textArr = [];
			if (errArr.length) {
				textArr.push(errArr.join(',') + ': invoice file Error;')
			}
			if (emtyArr.length) {
				textArr.push(emtyArr.join(',') + ': invoice file have not sent;')
			}
			if (textArr.length) {
				this.$message.error({
					message: textArr.join('<br/>'),
					dangerouslyUseHTMLString: true,
				});
			}
		},
		createAdv() {
			this.$router.push({ path: "/advCreate" });
		},
		edit(row){
			window.open(`/advSummaryEdit?id=${row.id}`);
		},
		editRule(){

		},
		async sortChange(column){
			if(column.order == 'ascending'){
				this.$set(this.order, 0, [column.prop, 'asc']);
			}else if(column.order == 'descending'){
				this.$set(this.order, 0, [column.prop, 'desc']);
			}else {
				this.order.splice(0,this.order.length);
			}
			await this.$refs.sl.refresh();
		},
		async addSummary() {
			await this.$validate(this.$refs.addForm);
            await this.$post('advSummary/create',this.addForm);
			await this.$refs.sl.refresh();
			this.showAddDialog = false;
		}
	}
};
</script>

<style scoped>
.bt-create {
  position: relative;
  right: 0px;
}
</style>
